import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";

import "../Body/Body.css";

export default function Body({ bannerData, links}) {
 
 

    
  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col>
              <div className="bannertextdesktop">
                <p>{htmlParser(bannerData.mastermindbannerheading)}</p>
              </div>
              <div className="bannertextsub">
                <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
                <p>{htmlParser(bannerData.mastermindsubheading2)}</p>
              </div>
            </Col>
          </Row>
          <Col>
            <div className="editionbox">
            <a
                href={links.mobileAppURL}
                  target="_blank"
                  rel="noreferrer"
                >
              <img
                src={
                  "https://stagingresources.swmc.com/mastermind/morganimg.webp"
                }
                className="morganimg img-fluild"
              ></img>
                </a>
              <div className="edition">
                <p className="textedition">
                  {" "}
                  {htmlParser(bannerData.monthedition)}
                </p>
              </div>
            </div>
            <div className="editionboxmobile">
            <a
                  href={links.mobileAppURL}
                  target="_blank"
                  rel="noreferrer"
                >
              <img
                src={
                  "https://d2b7dijo04ypct.cloudfront.net/mania/PostEvent/morganimg.webp"
                }
                className="mobilemorgan img-fluild"
              ></img>
               </a>
              <div className="editionmobilebox">
                <p className="editionmobiletext">
                  {" "}
                  {htmlParser(bannerData.monthedition)}
                </p>
              </div>
            </div>
          </Col>
        </Container>
      </div>
     
    </>
  );
}
